const isBonusRewardSection = (
  s: PerformanceBoardTypes.SlideOut.SlideOutSection,
): s is PerformanceBoardTypes.SlideOut.BonusRewardSection => {
  return s.sectionType === 'Bonus Reward';
};

export default isBonusRewardSection;
